import { type Location } from '@koala/sdk';
import { useEffect } from 'react';
import { type ConnectedProps, connect } from 'react-redux';
import { compose } from 'redux';
import { withTheme } from 'styled-components';
import { StyledLinkButton } from '../../styles';
import { StyledAccountInfoContainer, StyledReferralCodeInstructions } from '../styles';
import { FavoriteLocationForm } from '@/components/account/accountInformation/favoriteLocation/form';
import { StyledSubheaderText, StyledStepContent } from '@/components/checkout/uielements';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { FeatureAccessor } from '@/components/featureAccessor';
import { LocationCard } from '@/components/locations/card';
import { Modal } from '@/components/uielements/modal';
import { FEATURE_FLAGS } from '@/constants/features';
import meActions from '@/redux/me/actions';
import { type RootState } from '@/types/app';

const containerId = 'favorite-location-container';

const _FavoriteLocation = ({ meFavoriteLocations, fetchMeFavoriteLocations }: ReduxProps) => {
  useEffect(() => {
    fetchMeFavoriteLocations();
  }, []);

  return (
    <FeatureAccessor featureFlag={FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED}>
      <StyledStepContent data-testid={containerId} $enabled={true}>
        <StyledAccountInfoContainer>
          <StyledSubheaderText>Favorite Location</StyledSubheaderText>
        </StyledAccountInfoContainer>
        {meFavoriteLocations && meFavoriteLocations.length ? (
          meFavoriteLocations.map((location: Location) => (
            <LocationCard
              location={location}
              favorites={true}
              key={location.id}
              editFavoriteLocation={true}
            />
          ))
        ) : (
          <Modal.Container
            trigger={(open) => (
              <StyledLinkButton onClick={open} $bold={true}>
                <StringAccessor
                  accessor="account.add_favorite_location_button"
                  tag={StyledReferralCodeInstructions}
                />
              </StyledLinkButton>
            )}
          >
            {(toggle) => <FavoriteLocationForm onToggle={toggle} />}
          </Modal.Container>
        )}
      </StyledStepContent>
    </FeatureAccessor>
  );
};

const mapStateToProps = (state: RootState) => ({
  meFavoriteLocations: state.app.me.favoriteLocations,
});

const mapDispatchToProps = {
  fetchMeFavoriteLocations: meActions.fetchMeFavoriteLocations,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export const FavoriteLocation = compose<any>(withTheme, connector)(_FavoriteLocation);
